export default __webpack_public_path__ + "static/media/illustration-tutorial.301be113.png";